var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortAsc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M8.62 15.5h6.76L12 18.88zM5 14l7 7 7-7zm0-4h14l-7-7z"
})));
export { SvgSortAsc as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjIgMTUuNUgxNS4zOEwxMiAxOC44OEw4LjYyIDE1LjVaTTUgMTRMMTIgMjFMMTkgMTRINVpNNSAxMEgxOUwxMiAzTDUgMTBaIiBmaWxsPSIjMzIzMjMyIi8+Cjwvc3ZnPgo=";